import styles from "./CreditCardInfoModal.module.scss";
import close from "../../../assets/icons/close.svg";
import Button from "../../button/Button";
import { useTranslation } from "react-i18next";

interface CreditCardInfoModalProps {
  setIsModalUpdatePayVisible: (arg: boolean) => void;
  setIsModalCardInfoVisible: (arg: boolean) => void;
  setIsModalProcessingVisible: (arg: boolean) => void;
  setIsModalUpdatePaySuccessfullyVisible: (arg: boolean) => void;
}

const CreditCardInfoModal: React.FC<CreditCardInfoModalProps> = ({
  setIsModalUpdatePayVisible,
  setIsModalCardInfoVisible,
  setIsModalProcessingVisible,
  setIsModalUpdatePaySuccessfullyVisible,
}) => {
  const showProcessingModal = () => {
    setIsModalProcessingVisible(true);

    setTimeout(() => {
      setIsModalProcessingVisible(false);
      setIsModalUpdatePaySuccessfullyVisible(true);
    }, 1000);
  };

  const { t } = useTranslation();
  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <p className={styles.root_header_title}>
          {t("Update Credit Card Information")}
        </p>
        <img
          src={close}
          alt="close"
          onClick={() => setIsModalCardInfoVisible(false)}
        />
      </div>
      <p className={styles.root_subtitle}>
        {t("Enter your new credit card details below")}
      </p>
      <p className={styles.root_subtitleModile}>
        Choose a new payment method for your Fortect subscription
      </p>
      <div className={styles.root_main}>
        <div className={styles.root_main_block}>
          <label className={styles.root_main_label}>{t("Card number")}</label>
          <input
            className={styles.root_main_cardNumber}
            type="text"
            placeholder="xxxx xxxx xxxx xxxx"
          />
          <div className={styles.root_main_block_frame} />
        </div>
        <div className={styles.root_main_block}>
          <label className={styles.root_main_label}>
            {t("Cardholder Name")}
          </label>
          <input
            className={styles.root_main_input}
            type="text"
            placeholder={t("Cardholder Name")}
          />
        </div>
        <div className={styles.root_main_data}>
          <div className={styles.root_main_data_date}>
            <label className={styles.root_main_label}>{t("Date")}</label>
            <div className={styles.root_main_data_date_inputs}>
              <input
                className={styles.root_main_data_date_input}
                type="text"
                placeholder="MM"
              />
              <input
                className={styles.root_main_data_date_input}
                type="text"
                placeholder="YY"
              />
            </div>
          </div>
          <div className={styles.root_main_data_code}>
            <label className={styles.root_main_label}>Security Code/CVV</label>
            <input
              className={styles.root_main_data_code_input}
              type="text"
              placeholder="CVV"
            />
            <div className={styles.root_main_data_code_frame} />
          </div>
        </div>
        <div className={styles.root_main_buttons}>
          <Button
            onClick={() => {
              setIsModalCardInfoVisible(false);
              showProcessingModal();
            }}
            text={t("Update Card")}
            classNames={styles.root_main_buttons_btn}
          />
          <Button
            onClick={() => {
              setIsModalCardInfoVisible(false);
              setIsModalUpdatePayVisible(true);
            }}
            text={t("Go Back")}
            type="default"
            classNames={styles.root_main_buttons_btn}
          />
        </div>
      </div>
    </div>
  );
};

export default CreditCardInfoModal;
